<template>
    <div>
        <div v-show="images.length" class="flex flex-wrap justify-center">
            <div
                    v-for="image in images"
                    class="w-1/4 m-3 p-2 bg-white shadow-lg cursor-pointer"
                    @click="zoomMe(image)"
            >
                <img :src="image" alt="" class="w-full h-auto">
            </div>
            <modal name="image-magnifier" height="auto" transition="slide">
                <div class="p-2 bg-white relative">
                    <div class="absolute w-full top-0 left-0 text-right">
                        <div class="font-bold text-aitems-700 p-2 cursor-pointer opacity-75 hover:text-aitems-900"
                             @click="$modal.hide('image-magnifier')">
                            <i class="fas fa-times-circle fa-3x"></i>
                        </div>
                    </div>
                    <img :src="selected" alt="">
                </div>
            </modal>
        </div>
        <div
            v-show="!images.length"
            class="w-1/3 mx-auto bg-indigo-400 rounded shadow-lg p-8 mt-4 text-white text-lg flex items-center"
        >
            <i class="fas fa-camera fa-3x"></i>
            <span class="ml-2">
                Nessun immagine per ora.
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        data: () => ({
            images: [],
            selected: '',
        }),
        inject: ['imageUploaderState'],
        props: ['model', 'id'],

        watch: {
            uploaded() {
                if (this.uploaded) {
                    axios.get(`/images/${this.model}/${this.id}/index`)
                        .then(({data}) => {
                            this.images = data;
                            this.$emit('reloaded');
                        })
                }
             }
        },

        computed: {
            uploaded() {
                return this.imageUploaderState.uploaded
            }
        },

        created() {
            axios.get(`/images/${this.model}/${this.id}/index`)
                .then(({data}) => this.images = data)
        },
        methods: {
            zoomMe(image) {
                this.selected = image;
                this.$modal.show('image-magnifier');
            }
        }
    }

</script>

<style scoped>

</style>